import React, { useCallback } from "react";
import { Drawer, Tooltip, Select } from "antd";
import {
  CloseIcon,
  IconInformationTemplateReport,
} from "../../../../../../asset";
import CustomDivider from "../../../../../../component/divider/CustomDivider";
import MSSDepot from "../../../../../order/invoice/__components/mss-depot/MSSDepot";
import DDLDatePeriod from "../../../../../../component/dropdown-list/ddl-date-period";
import MultipleSelectDeliveryAssociateStatus from "../../../../../../component/multiple-select/delivery-associate-status";
import MultipleSelectDriverType from "../../../../../../component/multiple-select/driver-type";
import MultipleSelectVehicleOwnership from "../../../../../../component/multiple-select/vehicle-ownership";
import MSSDeliveryAssociateReport from "../mss-delivery-associate";

const DrawerReportDeliveryAssociate = ({ onClose, open, applyFilter }) => {
  const onClickApplyFilter = useCallback(() => {
    if (applyFilter) {
      applyFilter();
    }
  }, [applyFilter]);

  return (
    <Drawer
      title={null}
      onClose={onClose}
      open={open}
      closeIcon={null}
      width={"548px"}
    >
      <div className="flex justify-end">
        <img
          onClick={onClose}
          src={CloseIcon}
          style={{ height: "18px", width: "18px", cursor: "pointer" }}
          alt="icon-close"
        />
      </div>
      <div className="container-content-filter-drawer-report">
        <span className="span-title-drawer-report">Filter Report</span>
        <div className="flex flex-col gap-2 h-[1000px] overflow-x-auto">
          <div className="flex gap-2">
            <span className="span-label-filter-template-name">
              Filter Template
            </span>
            <Tooltip
              color="#C4C4C4"
              title={
                <span className="span-tooltip-title">
                  Type here directly to save a new template name or you can
                  select and replace existing one.
                </span>
              }
              placement="right"
            >
              <img src={IconInformationTemplateReport} alt="icon-information" />
            </Tooltip>
          </div>
          <div className="container-save-template">
            <Select
              placeholder="Select Filter Template"
              style={{ width: "80%" }}
              size="large"
            />
            <button className="btn-save-filter-template">Save Filter</button>
          </div>
          <CustomDivider name="Filter Data" />
          <div className="field-container">
            <span className="span-label-filter-template-name">Depot</span>
            <MSSDepot />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">Period Date</span>
            <DDLDatePeriod />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">
              Delivery Associate Status
            </span>
            <MultipleSelectDeliveryAssociateStatus />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">Driver Type</span>
            <MultipleSelectDriverType />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">
              Vehicle Owership
            </span>
            <MultipleSelectVehicleOwnership />
          </div>
          <div className="field-container">
            <span className="span-label-filter-template-name">
              Delivery Associate
            </span>
            <MSSDeliveryAssociateReport />
          </div>
        </div>
        <div className="container-btn-filter">
          <button className="btn-reset-filter">Reset</button>
          <button className="btn-apply-filter" onClick={onClickApplyFilter}>
            Apply
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default DrawerReportDeliveryAssociate;
